import MapBrowserEventClass, * as MapBrowserEventModule from './../node_modules/ol/MapBrowserEvent.js';

// Create a wrapper class
class MapBrowserEvent extends MapBrowserEventClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in MapBrowserEventModule) {
    if (key !== "default") {
        MapBrowserEvent[key] = MapBrowserEventModule[key];
    }
}

export default MapBrowserEvent;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/MapBrowserEvent.js';